import { render, staticRenderFns } from "./DeleteProductModal.vue?vue&type=template&id=7948ed5d&scoped=true&"
import script from "./DeleteProductModal.vue?vue&type=script&lang=js&"
export * from "./DeleteProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7948ed5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7948ed5d')) {
      api.createRecord('7948ed5d', component.options)
    } else {
      api.reload('7948ed5d', component.options)
    }
    module.hot.accept("./DeleteProductModal.vue?vue&type=template&id=7948ed5d&scoped=true&", function () {
      api.rerender('7948ed5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Content/components/DeleteProductModal.vue"
export default component.exports